import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { RouterModule } from '@angular/router';
import { Category } from '@common/category';
import { GalaxyCardComponent } from '@app/components/ui/galaxy-card/galaxy-card.component';
import { GalaxyButtonDirective } from '@app/directives/galaxy-button.directive';
import { GalaxyRippleDirective } from '@app/directives/galaxy-ripple.directive';
import { AnimateStaggerDirective } from '@app/directives/animate-stagger.directive';

@Component({
  selector: 'app-categories-highlight',
  imports: [
    RouterModule,
    GalaxyCardComponent,
    GalaxyButtonDirective,
    GalaxyRippleDirective,
    AnimateStaggerDirective,
  ],
  templateUrl: './categories-highlight.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./categories-highlight.component.css'],
})
export class CategoriesHighlightComponent {
  @Input() categories: Category[] | null = [];
}
